<script>
	export default {
		//HTTP地址
		HTTPURL: "https://www.cloud-ming.com",
		//项目名称
		projectName: "ZhongMing",
		fitData: {
			//屏幕大小
			windowSize: {
				width: 1920,
			},
			//适配的尺寸大小
			fontSize: 10
		},
	};
</script>